







import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: {
    PageTitle,
    AdminIframe,
  },
})
export default class DesignPopup extends Vue {
  private get remoteSrc() {
    const url = new URL(process.env.VUE_APP_ADMIN_REMOTE_URL + this.$route.fullPath);
    url.searchParams.set('serviceType', 'PREMIUM');

    return url.toString();
  }
}
